import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import ChecklistTypePickerModal from './ChecklistTypePickerModal'
import FilterLink from '../../../components/filter/FilterLink'

const ChecklistTypePicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation(['checklistTypes', 'common'])
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiPriceTag3Line'}
        label={label || t('checklistTypes:type')}
        value={compactString(value, { t: t, tField: 'typeIds' })}
        onClick={() => setOpen(true)}
      />
      <ChecklistTypePickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default ChecklistTypePicker
